module.exports = __webpack_public_path__ + "img/liucheng.d4961460.png";